import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { BsCalendarCheckFill } from "react-icons/bs";
import { MdAccessTime, MdOutlineDeveloperMode } from "react-icons/md";
import { AiFillSchedule } from "react-icons/ai";
import { FiUser } from "react-icons/fi";
import Swal from "sweetalert2";
import SummaryApi from "../common";
import dummyimage from "../asset/person.png";
import parse, { domToReact } from "html-react-parser";
import logo from "../asset/logo.png";

const StudentSelectedCourseDetails = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
const [showFullDescription, setShowFullDescription] = useState(false);
  const [instructor, setInstructor] = useState(null);
  const [timeslots, setTimeslots] = useState([]);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [isNextEnabled, setIsNextEnabled] = useState(false);

  // Get data from sessionStorage with fallbacks
  const selectedInstructorId = sessionStorage.getItem("selectedInstructorId");
  const selectedCourseId = sessionStorage.getItem("selectedCourseId");
  const selectedTimeSlotId = sessionStorage.getItem("selectedTimeSlotId");

  console.log("SessionStorage Data:", {
    selectedInstructorId,
    selectedCourseId,
    selectedTimeSlotId,
    student_id: sessionStorage.getItem("student_id")
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Check if required data exists
        if (!selectedInstructorId || !selectedCourseId) {
          console.error("Missing data:", { selectedInstructorId, selectedCourseId });
          setError("Missing instructor or course selection. Please go back and select again.");
          setLoading(false);
          
          // Show alert and redirect after a delay
          setTimeout(() => {
            Swal.fire({
              icon: 'warning',
              title: 'Selection Missing',
              text: 'Please select an instructor and course again.',
              confirmButtonText: 'Go Back'
            }).then(() => {
              navigate("/student-panel/course-selection");
            });
          }, 1000);
          return;
        }

        // Fetch Instructor
        const instructorRes = await fetch(
          SummaryApi.instructordetailsById.url,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ instructor_id: selectedInstructorId }),
          }
        );

        const instructorData = await instructorRes.json();

        if (instructorData.status && instructorData.data) {
          const inst = instructorData.data;
          setInstructor({
            id: inst.instructor_id,
            name: `${inst.first_name} ${inst.last_name}`,
            title: inst.job_title || inst.about_instructor1 || "Instructor",
            rating: Number(inst.rating) || 0,
            experience:
              inst.total_experience !== "N/A"
                ? `${inst.total_experience}+ Years Experience`
                : "Experience Not Available",
            image: inst.instructor_image
              ? `${SummaryApi.instructorImage.url.replace("api", "")}${inst.instructor_image.replace("/api", "")}`
              : dummyimage,
          });
        } else {
          setError("Instructor not found.");
        }

        // Fetch Time Slots for the selected instructor
        const timeSlotRes = await fetch(
          SummaryApi.timeslotByCourseIdAndInstructorId.url,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              course_id: Number(selectedCourseId),
              instructor_id: Number(selectedInstructorId),
            }),
          }
        );

        const timeSlotData = await timeSlotRes.json();
        console.log("Fetched timeslots:", timeSlotData);
        
        if (timeSlotData.status && Array.isArray(timeSlotData.data)) {
          // Filter only upcoming timeslots
          const upcomingTimeSlots = timeSlotData.data.filter(timeslot => 
            isUpcomingTimeSlot(timeslot)
          );
          setTimeslots(upcomingTimeSlots);
          
          // Auto-select the previously selected timeslot if available
          if (selectedTimeSlotId) {
            const preselectedSlot = upcomingTimeSlots.find(
              slot => String(slot.time_slot_id) === String(selectedTimeSlotId)
            );
            if (preselectedSlot) {
              setSelectedTimeSlot(preselectedSlot);
              setIsNextEnabled(true);
              console.log("Auto-selected timeslot:", preselectedSlot);
            }
          }
        }

        // Fetch Course Details
        const courseRes = await fetch(SummaryApi.coursedetailsById.url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ course_id: Number(selectedCourseId) }),
        });

        const courseData = await courseRes.json();
        if (courseData.status && courseData.data) {
          setCourse(courseData.data);
        } else {
          setError("Course details not found.");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Error loading data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedInstructorId, selectedCourseId, selectedTimeSlotId, navigate]);








const ExpandableContent = ({ children, maxHeight = 240 }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <div
        className={`relative overflow-hidden transition-all duration-300`}
        style={{
          maxHeight: expanded ? "none" : `${maxHeight}px`,
        }}
      >
        {children}

        {!expanded && (
          <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-white to-transparent"></div>
        )}
      </div>

      <button
        onClick={() => setExpanded(!expanded)}
        className="mt-2 text-blue-600 hover:text-blue-800 font-medium text-sm"
      >
        {expanded ? "Show less" : "Read more"}
      </button>
    </div>
  );
};














  // Handle back navigation properly
  const handleBackClick = () => {
    // Keep the course selection but allow changing instructor
    sessionStorage.removeItem("selectedInstructorId");
    sessionStorage.removeItem("selectedTimeSlotId");
    navigate("/student-panel/instructor-selection", {
      state: { 
        selectedCourseId: selectedCourseId,
        preserveCourse: true 
      }
    });
  };

  // Check if timeslot is upcoming
  const isUpcomingTimeSlot = (timeslot) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const startDate = new Date(timeslot.start_date);
    startDate.setHours(0, 0, 0, 0);
    
    return startDate >= today;
  };

  // Get available days from timeslot
  const getAvailableDays = (timeslot) => {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const availableDays = days.filter(day => timeslot[day] && timeslot[day] !== "N/A");
    
    return availableDays.map(day => {
      const timeRange = timeslot[day];
      return {
        day: day.charAt(0).toUpperCase() + day.slice(1),
        timeRange: formatTime(timeRange)
      };
    });
  };

  // Get formatted schedule string for enrollment
  const getFormattedSchedule = (timeslot) => {
    const availableDays = getAvailableDays(timeslot);
    if (availableDays.length === 0) return "Schedule not available";
    
    return availableDays.map(dayInfo => 
      `${dayInfo.day}: ${dayInfo.timeRange}`
    ).join(', ');
  };

  const formatTime = (timeStr) => {
    if (!timeStr || timeStr === "N/A" || timeStr === "null" || timeStr === "undefined") {
      return "N/A";
    }
    
    try {
      // If it's already in a clean format like "15:00:00-16:00:00"
      if (timeStr.includes('-')) {
        const [startTime, endTime] = timeStr.split('-');
        
        const formatSingleTime = (time) => {
          const timePart = time.trim();
          const timeParts = timePart.split(':');
          
          if (timeParts.length >= 2) {
            const hours = parseInt(timeParts[0]);
            const minutes = timeParts[1];
            
            // Convert to 12-hour format
            const period = hours >= 12 ? 'PM' : 'AM';
            const twelveHour = hours % 12 || 12;
            
            return `${twelveHour}:${minutes} ${period}`;
          }
          return timePart;
        };
        
        return `${formatSingleTime(startTime)} - ${formatSingleTime(endTime)}`;
      }
      
      // For single time values
      const timePart = timeStr.trim();
      const timeParts = timePart.split(':');
      
      if (timeParts.length >= 2) {
        const hours = parseInt(timeParts[0]);
        const minutes = timeParts[1];
        const period = hours >= 12 ? 'PM' : 'AM';
        const twelveHour = hours % 12 || 12;
        
        return `${twelveHour}:${minutes} ${period}`;
      }
      
      return timeStr;
    } catch (error) {
      console.error("Error formatting time:", timeStr, error);
      return timeStr;
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  // Helper function for parsing HTML and adding a checkmark icon
  const renderListWithCheckmarks = (htmlContent) => {
    if (!htmlContent) {
      return <p>No content available.</p>;
    }

    // A function to replace 'li' elements with one that includes the FaCheckCircle icon
    const replaceNode = (domNode) => {
      // Check for li elements
      if (domNode.type === 'tag' && domNode.name === "li") {
        return (
          <li key={Math.random()} className="flex items-start gap-2 mb-2 text-gray-700">
            <FaCheckCircle className="text-blue-600 mt-1 flex-shrink-0" />
            <span className="flex-grow">{domToReact(domNode.children, replaceNode)}</span>
          </li>
        );
      }
      // Recursively process children of other tags (like ul, ol, p, etc.)
      if (domNode.children) {
        return domToReact(domNode.children, replaceNode);
      }
    };
    
    // Custom function to handle replacement on the root level and recursively
    return parse(htmlContent, { replace: replaceNode });
  };


  const handleNextClick = async () => {
    if (!isNextEnabled || !selectedTimeSlot) {
      console.log("Next button disabled or no timeslot selected");
      return;
    }

    const studentId = localStorage.getItem("student_id");
    const instructorId = sessionStorage.getItem("selectedInstructorId");
    const courseId = sessionStorage.getItem("selectedCourseId");
    
    // Validate all required data
    if (!studentId || !instructorId || !courseId || !selectedTimeSlot || !selectedTimeSlot.time_slot_id) {
      Swal.fire("Error", "Missing selection details. Please ensure all fields are selected.", "error");
      return;
    }

    const enrollmentDate = new Date().toISOString();
    const formattedSchedule = getFormattedSchedule(selectedTimeSlot);

    try {
      const res = await fetch(SummaryApi.assignCourseToStudent.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          student_id: Number(studentId),
          course_id: Number(courseId),
          instructor_id: Number(instructorId),
          time_slot_id: selectedTimeSlot.time_slot_id,
          time_slot: formattedSchedule,
          enrollment_date: enrollmentDate,
        }),
      });

      const data = await res.json();
      console.log("Enrollment API Response:", data);

      if (data.status) {
        Swal.fire("Success", "You have been enrolled successfully!", "success");
        // Clear session storage after successful enrollment
        sessionStorage.removeItem("selectedInstructorId");
        sessionStorage.removeItem("selectedTimeSlotId");
        sessionStorage.removeItem("selectedCourseId");
        navigate("/student-panel/course-all-set");
      } else {
        Swal.fire("Error", data.message || "Enrollment failed.", "error");
      }
    } catch (error) {
      console.error("Enrollment error:", error);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  const handleTimeSlotSelect = (slot) => {
    console.log("Selected timeslot:", slot);
    setSelectedTimeSlot(slot);
    setIsNextEnabled(true);
    // Also update sessionStorage
    sessionStorage.setItem("selectedTimeSlotId", slot.time_slot_id);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-lg text-[#1C3664]">Loading course details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-red-500 text-lg text-center">
          {error}
          <br />
          <button
            onClick={() => navigate("/student-panel/course-selection")}
            className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Go Back to Course Selection
          </button>
        </div>
      </div>
    );
  }

  return (
    // Main background is white
    <div className="relative flex flex-col items-center justify-center w-full min-h-screen bg-white font-inter text-white">

      {/* Logo */}
      <div className="w-full flex justify-center mt-6 mb-4">
        <img src={logo} alt="logo" className="w-40 sm:w-48 md:w-56 lg:w-64 object-contain" />
      </div>

  <div
    className="
      relative z-10 bg-[#1C3664] shadow-2xl rounded-2xl
      w-[90%] mt-6 mb-16 px-6 sm:px-8 md:px-10 lg:px-12 py-20 
      overflow-hidden
    "
  >
        {/* Header */}
        <div className="text-center mb-8 text-white">
          <h2 className="text-[32px] sm:text-[36px] md:text-[38px] font-bold mb-2">
            COURSE DETAILS
            <span className="block w-16 h-[3px] bg-white mx-auto mt-1 relative">
              <span className="block w-2 h-2 bg-white rotate-45 absolute -bottom-1 left-1/2 -translate-x-1/2"></span>
            </span>
          </h2>
          <h3 className="text-[#e69818] text-[24px] font-bold">
            {course?.course_title || "Course Title"}
          </h3>
          <p className="text-[16px] sm:text-[17px] opacity-90 text-white">
            {course?.subtitle || "Course subtitle"}
          </p>
        </div>

        {/* Content Box - Now directly inside the dark blue container */}
        <div className="bg-white rounded-lg shadow-xl w-full p-6 sm:p-8 text-gray-800">
          

          {/* Main Content Grid (Responsive Layout) */}
          <div className="flex flex-col md:flex-row pt-2 w-full gap-8">
            
            {/* Left Section (Course Info Cards) */}
            <div className="flex-1 space-y-6">
              
              {/* What You'll Learn Card */}
              <div className="border border-blue-200 rounded-lg p-6 bg-white shadow-sm">
                <h4 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <MdOutlineDeveloperMode className="text-orange-500" size={24} />
                  What You'll Learn
                </h4>
      <ExpandableContent maxHeight={240}>
  <div className="text-gray-700 space-y-3">
    {renderListWithCheckmarks(course?.student_learning)}
  </div>
</ExpandableContent>

              </div>

              {/* Course Details */}
              <div className="border border-blue-200 rounded-lg p-6 bg-white shadow-sm">
                <h4 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <BsCalendarCheckFill className="text-blue-500" size={24} />
                  Course Details
                </h4>
                <div className="space-y-3 text-gray-700">
                  <p className="flex items-center gap-2">
                    <MdAccessTime className="text-gray-600" />
                    <strong>Duration:</strong> {course?.course_duration || "N/A"}
                  </p>
                  <p className="flex items-center gap-2">
                    <FaCheckCircle className="text-green-600" />
                    <strong>Level:</strong> {course?.diffculty_level || "N/A"}
                  </p>
                  <p className="flex items-center gap-2">
                    <strong>Language:</strong> {course?.language_instruction || "N/A"}
                  </p>
                  <p className="flex items-center gap-2">
                    <strong>Rating:</strong> {course?.rating || "N/A"}
                  </p>
                </div>
              </div>

              {/* Prerequisites */}
              {course?.learning_requirements && course.learning_requirements !== "N/A" && (
                <div className="border border-blue-200 rounded-lg p-6 bg-white shadow-sm">
                  <h4 className="text-xl font-semibold text-gray-800 mb-4">
                    Prerequisites
                  </h4>
   <ExpandableContent maxHeight={240}>
  <div className="text-gray-700 space-y-3">
    {renderListWithCheckmarks(course.learning_requirements)}
  </div>
</ExpandableContent>
                </div>
              )}
            </div>

            {/* Right Section (Instructor & Batches) */}
            <div className="flex-1 md:border-l border-gray-300 pt-6 md:pt-0 md:pl-8 space-y-6">
              
              {/* Instructor */}
              <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FiUser className="text-orange-500" size={24} /> Your Instructor
                </h4>

                {instructor ? (
                  <div className="flex items-center gap-4 p-4 border rounded-lg bg-gray-50">
                    <img
                      src={instructor.image}
                      alt={instructor.name}
                      className="w-20 h-20 rounded-md object-cover"
                    />
                    <div className="text-gray-700">
                      <p>
                        <strong>Name:</strong> {instructor.name}
                      </p>
                      <p>
                        <strong>Designation:</strong> {instructor.title}
                      </p>
                      <p>
                        <strong>Experience:</strong> {instructor.experience}
                      </p>
                      <p className="flex items-center gap-1">
                        <strong>Rating:</strong>
                        {[...Array(5)].map((_, i) => (
                          <FaCheckCircle 
                            key={i} 
                            className={i < instructor.rating ? "text-green-600" : "text-gray-300"} 
                          />
                        ))}
                        <span className="ml-1">({instructor.rating})</span>
                      </p>
                    </div>
                  </div>
                ) : (
                  <p className="text-gray-600">Instructor not assigned yet.</p>
                )}
              </div>

              {/* Course Description */}
    <div>
  <h4 className="text-xl font-semibold text-gray-800 mb-4">
    Course Description
  </h4>
  <div className="relative">
    <p className="text-gray-700 leading-relaxed p-4 border rounded-lg bg-gray-50">
      {showFullDescription 
        ? course?.description || "No description available."
        : (course?.description 
            ? course.description.split(' ').slice(0, 50).join(' ') + (course.description.split(' ').length > 50 ? '...' : '')
            : "No description available."
          )
      }
    </p>
    {course?.description && course.description.split(' ').length > 50 && (
      <button
        onClick={() => setShowFullDescription(!showFullDescription)}
        className="mt-2 text-blue-600 hover:text-blue-800 font-medium text-sm"
      >
        {showFullDescription ? "Show less" : "Read more"}
      </button>
    )}
  </div>
</div>

              {/* Available Batches */}
             <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <AiFillSchedule className="text-orange-500" size={24} />
                  Available Batches
                  <span className="ml-auto text-sm text-blue-500">
                    Select Your Batch
                  </span>
                </h4>
                {timeslots.length > 0 ? (
                  <div className="space-y-4">
                    {timeslots.map((slot, index) => {
                      const isSelected =
                        selectedTimeSlot &&
                        String(selectedTimeSlot.time_slot_id) ===
                          String(slot.time_slot_id);
                      return (
                        <div
                          key={slot.time_slot_id}
                          onClick={() => handleTimeSlotSelect(slot)}
                          className={`p-4 rounded-lg border cursor-pointer transition ${
                            isSelected
                              ? "bg-blue-50 border-blue-500 border-2"
                              : "bg-gray-50 border-gray-200 hover:bg-gray-100"
                          }`}
                        >
                          <div className="flex justify-between items-start mb-3">
                            <span className="font-bold text-lg text-blue-700 capitalize">
                              {slot.batch_name || `Batch ${index + 1}`}
                              {isSelected && (
                                <span className="ml-2 text-sm text-green-600 font-normal">
                                  ✓ Selected
                                </span>
                              )}
                            </span>
                            <div className="text-right">
                              <span className="text-sm font-medium text-gray-700 bg-blue-100 px-3 py-1 rounded">
                                {formatDate(slot.start_date)} -{" "}
                                {formatDate(slot.end_date)}
                              </span>
                            </div>
                          </div>
                          <div className="grid grid-cols-1 gap-2">
                            {getAvailableDays(slot).map((dayInfo, dayIndex) => (
                              <div
                                key={dayIndex}
                                className="flex items-center justify-between bg-white px-3 py-1 rounded border"
                              >
                                <span className="font-medium text-gray-700">
                                  {dayInfo.day}
                                </span>
                                <span className="text-sm text-blue-600 font-medium">
                                  {dayInfo.timeRange}
                                </span>
                              </div>
                            ))}
                          </div>
                          {isSelected && (
                            <div className="mt-3 p-2 bg-green-100 border border-green-200 rounded">
                              <p className="text-green-700 text-sm font-medium text-center">
                                ✓ This batch is selected. Ready to enroll!
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-6 bg-yellow-50 rounded-lg border border-yellow-200">
                    <p className="text-yellow-700 font-medium">
                      No upcoming batches available
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Navigation Buttons */}
        <div className="w-full mt-12 flex justify-between px-2">
          <button
            type="button"
            className="border border-white text-white rounded-md py-3 px-6 text-lg font-medium hover:bg-white hover:text-[#1C3664] transition shadow-md"
            onClick={handleBackClick}
          >
            &lt; Back
          </button>
          <button
            type="button"
            disabled={!isNextEnabled}
            className={`rounded-md py-3 px-8 text-lg font-medium shadow-md transition ${
              isNextEnabled
                ? " bg-blue-500 text-white hover:bg-blue-600 cursor-pointer"
                : "bg-gray-400 text-white cursor-not-allowed"
            }`}
            onClick={handleNextClick}
          >
            Enroll Now &gt;
          </button>
        </div>

      </div>
    </div>
  );
};

export default StudentSelectedCourseDetails;